// GENERATED CODE -- DO NOT EDIT!
// To re-generate this file:
// start local dev server (w/ backend turned on)
// go run ./services/rewards/cmd/generate-translations
import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import type {BadgeInfo} from "../badge-translations.ts";

export const getContextFeedbackBadges: () => Record<string, BadgeInfo> =
    memoize(
        (): Record<string, BadgeInfo> => ({
            leveloneanswervotecountbadge: {
                description: t`Good Answer`,
                extendedDescription: t`Post an answer that earns 10+ votes`,
            },
            leveltwoanswervotecountbadge: {
                description: t`Great Answer`,
                extendedDescription: t`Post an answer that earns 25+ votes`,
            },
            levelthreeanswervotecountbadge: {
                description: t`Incredible Answer`,
                extendedDescription: t`Post an answer that earns 50+ votes`,
            },
            levelonequestionvotecountbadge: {
                description: t`Good Question`,
                extendedDescription: t`Ask a question that earns 10+ votes`,
            },
            leveltwoquestionvotecountbadge: {
                description: t`Great Question`,
                extendedDescription: t`Ask a question that earns 25+ votes`,
            },
            levelthreequestionvotecountbadge: {
                description: t`Incredible Question`,
                extendedDescription: t`Ask a question that earns 50+ votes`,
            },
        }),
    );
